import { Checkbox } from "@components";
import { BaseCurrencyInput } from "@components/CurrencyInput/BaseCurrencyInput";
import { useEffect, useState } from "react";
import styles from "../../../../styles/beneficios/steps/BenefitTypeSelectStepOld.module.scss";
import { Button } from "../../../components/Button";
import { Hairline } from "../../../components/Hairline";
import { Input } from "../../../components/Input";
import { Label } from "../../../components/Label";
import { Message } from "../../../components/Message";
import { Radio } from "../../../components/Radio";
import { If } from "../../../components/control-statements";
import { Icon } from "../../../components/core/Icon";
import { Select } from "@components";
import dayjs from "dayjs";
import { GodMode } from "shared/core/GodMode";
import { Environment } from "shared/core/Environment";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
import { BenefitImage, BenefitImageOld } from "./BenefitImageOld";
import { UserStorage } from "shared/tools/UserStorage";

const st = (className) => styles[className];

export const BenefitInsertCodeStepOld = ({
  benefit,
  partners = [],
  onChange,
  programByPoint,
}) => {
  const [code, setCode] = useState(null);
  const [value, setValue] = useState(0);
  const [multiple_items, setMultipleItems] = useState(false);
  const [single_use, setSingleUse] = useState(benefit.single_use || 1);
  const [min_order, setMinOrder] = useState(0);
  const [expiration_days, setExpirationDays] = useState(0);
  const [spend_days, setSpendDays] = useState(0);
  const [sku, setSku] = useState("");
  const [skus, setSkus] = useState([]);
  const [partner_id, setPartnerId] = useState(null);
  const [description, setDescription] = useState("");
  const [sellable, setSellable] = useState(false);
  const [isPublic, setIsPublic] = useState(false);
  const [price, setPrice] = useState(0);

  const [group, setGroup] = useState("");
  const [justification, setJustification] = useState("");

  const [image, setImage] = useState(null);

  const allowsUseByEnvironment =
    Environment.id === 52 || Environment.id === 34 || Environment.id === 37;

  useEffect(() => {
    onChange({
      ...benefit,
      code,
      value,
      single_use,
      min_order,
      expiration_days,
      spend_days,
      multiple_items,
      skus,
      description,
      image,
      partner_id,
      sellable,
      public: isPublic,
      price,
      group,
      justification,
    });
  }, [
    code,
    value,
    single_use,
    min_order,
    expiration_days,
    spend_days,
    multiple_items,
    skus,
    description,
    partner_id,
    sellable,
    isPublic,
    price,
    group,
    justification,
  ]);

  const isPercentage =
    ["PERCENTAGE_DISCOUNT", "CASHBACK", "PRODUCT_DISCOUNT"].indexOf(
      benefit.type,
    ) > -1;

  const addSKU = () => {
    const index = skus.indexOf(sku);

    if (index !== -1 || sku.length === 0) return;

    setSkus((prevState) => [...prevState, sku]);
    setSku("");
  };

  useEffect(() => {
    if (skus?.length <= 1) setMultipleItems(false);
  }, [skus]);

  const calculateExpirationDate = (days) => {
    const expirationDate = dayjs().add(days, "day");

    return expirationDate.format("DD/MM/YYYY");
  };

  const [holdingId, setHoldingId] = useState(null);

  const loadEnvironment = async () => {
    setHoldingId(await EnvironmentStorage.getEnvironmentHoldingId());
  };

  useEffect(() => {
    loadEnvironment();
  }, []);

  return (
    <div>
      <Label text={"Insira o código do benefício"} />
      <Input
        design="two"
        label="Código do benefício"
        value={code}
        onChange={(text) =>
          setCode(
            (text.target.value || "").toUpperCase().replace(/[^A-Z0-9]/gi, ""),
          )
        }
        max={15}
      />

      <If cond={code?.length == 15}>
        <Message className="mt-10">Limite de 15 caracteres</Message>
      </If>

      <Hairline />

      <Label text={"Insira a descrição do benefício"} />
      <Input
        value={description}
        placeholder="Ex: 10% OFF em produtos selecionados"
        onChange={(e) => setDescription(e.target.value || "")}
        max={150}
        maxLength={150}
      />

      <Hairline />

      <BenefitImageOld
        image={image}
        onChange={(image) => {
          setImage(image);
        }}
      />
      <Hairline />

      <If
        cond={["PRODUCT_CASH_DISCOUNT", "PRODUCT_DISCOUNT"].includes(
          benefit.type,
        )}
      >
        <Label text={"Adicione SKU's"} />
        <Input
          className="mb-0"
          value={sku}
          onChange={(e) => setSku(e.target.value.trim() || "")}
          placeholder="000000000000000"
        />
        <Button
          onClick={addSKU}
          className={"w-100 mt-10 mb-20"}
          design="primary"
        >
          Adicionar
        </Button>

        <Label text={`SKU's (${skus.length})`} />
        <div className={styles.skus}>
          {skus.length > 0 ? (
            skus.map((sku) => {
              return (
                <div className={styles.sku} key={sku}>
                  <p>{sku}</p>
                  <div
                    className={styles.remove}
                    onClick={() =>
                      setSkus((prevState) => prevState.filter((s) => s !== sku))
                    }
                  >
                    <Icon name="fa-times" regular />
                  </div>
                </div>
              );
            })
          ) : (
            <div className={styles.emptySKUS}>
              <div className={styles.icon}>
                <Icon name="fa-folder-open" light />
              </div>
              <p>Nenhum sku foi adicionado</p>
            </div>
          )}
        </div>
        <Checkbox
          className="mt-20 mb-20"
          checked={multiple_items}
          disabled={skus.length <= 1}
          onChange={() => setMultipleItems(!multiple_items)}
        >
          Permitir múltiplos subitens?
        </Checkbox>
        {!multiple_items ? (
          <Message text="O cupom será liberado para uso somente quando um único SKU selecionado no produto esteja dentro dos subitems liberados no cupom, aplicando desconto em todas as unidades do subitem, mas somente em uma unidade do produto." />
        ) : (
          <Message text="O cupom será liberado para uso quando um ou mais SKU's selecionados no produto estejam dentro dos subitems liberados no cupom, aplicando desconto em todas as unidades do subitem, mas somente em uma unidade do produto." />
        )}
        <Hairline />
      </If>

      <Label text={"Determine o tipo de cupom"} />
      <If cond={!benefit?.template}>
        <Radio
          text="Uso único"
          family="use"
          className="mb-10"
          value={1}
          checked={single_use}
          onChange={() => setSingleUse(1)}
        />
        <Radio
          text="Uso múltiplo"
          family="use"
          className="mb-10"
          value={0}
          checked={single_use}
          onChange={() => setSingleUse(0)}
        />
        <Radio
          text="Uso contínuo"
          family="use"
          className="mb-10"
          value={2}
          checked={single_use}
          onChange={() => setSingleUse(2)}
        />
        {allowsUseByEnvironment && (
          <Radio
            text="Uso único no ambiente"
            family="use"
            value={4}
            checked={single_use}
            onChange={() => setSingleUse(4)}
          />
        )}
      </If>

      <Hairline />
      <div className="d-flex">
        <If cond={benefit.type != "FREE_DELIVERY"}>
          <If
            cond={
              (benefit.type == "CASHBACK" && !programByPoint) ||
              benefit.type != "CASHBACK"
            }
          >
            <BaseCurrencyInput
              design="two"
              label="Valor do beneficio"
              className="w-100 mr-15"
              value={value}
              prefix={isPercentage ? "" : "R$ "}
              suffix={isPercentage ? " %" : ""}
              onChange={(v) => setValue(v)}
            />
            <BaseCurrencyInput
              design="two"
              label="Pedido mínimo"
              className="w-100"
              value={min_order}
              onChange={(v) => setMinOrder(v)}
            />
          </If>
          <If cond={programByPoint && benefit.type == "CASHBACK"}>
            <div className="d-flex flex-column">
              <div className="d-flex align-center">
                <BaseCurrencyInput
                  design="two"
                  className="w-100"
                  suffix={" gastos"}
                  value={100}
                  disabled
                />
                <span className={styles.equal}>=</span>
                <BaseCurrencyInput
                  design="two"
                  suffix={` ${value === 1 ? "ponto" : "pontos"}`}
                  prefix={""}
                  precision={0}
                  className="w-100"
                  value={value || 0}
                  onChange={(percentage) => {
                    setValue(percentage);
                  }}
                />
              </div>
              <BaseCurrencyInput
                design="two"
                label="Pedido mínimo"
                className="w-100"
                value={min_order}
                onChange={(v) => setMinOrder(v)}
              />
            </div>
          </If>
        </If>
        <If cond={benefit.type == "FREE_DELIVERY"}>
          <BaseCurrencyInput
            design="two"
            label="Pedido mínimo"
            className="w-100"
            value={min_order}
            onChange={(v) => setMinOrder(v)}
          />
        </If>
      </div>
      <Hairline />
      <Label
        text={`Defina a expiração ${
          benefit.type === "CASHBACK" ? "de ganho e de gasto deste " : "do "
        }benefício`}
      />
      <BaseCurrencyInput
        design="two"
        prefix={""}
        precision={0}
        className="mb-0"
        value={expiration_days}
        onChange={(v) => setExpirationDays(v)}
        suffix={
          benefit.type === "CASHBACK" ? " dias de expiração de ganho" : " dias"
        }
      />
      <If cond={benefit.type === "CASHBACK"}>
        <BaseCurrencyInput
          design="two"
          prefix={""}
          precision={0}
          value={spend_days}
          onChange={(v) => setSpendDays(v)}
          suffix={" dias de expiração de gasto"}
        />
      </If>
      <Message className="mt-20">
        A expiração deste benefício inicia a partir do momento que o usuário o
        recebe. Se adicionado à carteira agora, o cupom expirará em{" "}
        {calculateExpirationDate(expiration_days)} às 23:59.
      </Message>
      <If cond={benefit.type === "CASHBACK"}>
        <Message className="mt-10">
          A expiração do gasto inicia após o uso do cupom. Se o cupom fosse
          utilizado agora, o cashback expiraria em{" "}
          {calculateExpirationDate(spend_days)} às 23:59.
        </Message>
      </If>

      <If cond={partners.length > 0}>
        <Hairline />
        <Label text={"Convênio"} />
        <Select
          value={partner_id}
          options={[
            { label: "Nenhum", value: null },
            ...partners.map((p) => ({ label: p.name, value: p.id })),
          ]}
          onChange={(e) => setPartnerId(e.target.value || "")}
        />
      </If>
      <If cond={GodMode.isGodMode || programByPoint}>
        <Hairline />
        <Checkbox
          className="mt-20 mb-10"
          checked={sellable}
          onChange={() => setSellable(!sellable)}
        >
          Disponibilizar para troca por pontos
        </Checkbox>
        <If cond={sellable}>
          <BaseCurrencyInput
            design="two"
            suffix={` ${price === 1 ? "ponto" : "pontos"}`}
            prefix={""}
            precision={0}
            className="w-100"
            value={price}
            onChange={(v) => setPrice(v)}
          />
        </If>
      </If>
      <Checkbox
        className="mt-10 mb-10"
        checked={isPublic}
        onChange={() => setIsPublic(!isPublic)}
      >
        Cupom disponível para todos
      </Checkbox>
      <If cond={Environment.id == 34}>
        <Hairline />
        <Input
          design="two"
          label="Grupo (3SCheckout)"
          className="mb-20"
          value={group}
          onChange={(e) => setGroup(e.target.value || "")}
        />
        <Input
          design="two"
          label="Justificativa (3SCheckout)"
          value={justification}
          onChange={(e) => setJustification(e.target.value || "")}
        />
      </If>
    </div>
  );
};
